module.exports = __webpack_public_path__ + "img/play.0c5ae399.svg";